import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatTime } from 'utils'

import Box from '@mui/material/Box'

interface Props {
  exposTimestamp?: string
  resaTimestamp?: string
  trafficTimestamp?: string
}

function LastDataTab({ exposTimestamp, resaTimestamp, trafficTimestamp }: Props) {
  const { t: translate } = useTranslation()

  return (
    <>
      {resaTimestamp && (
        <Box>
          {translate('tableSourceData.resa')}: {formatTime(resaTimestamp)}
        </Box>
      )}
      {trafficTimestamp && (
        <Box>
          {translate('tableSourceData.traffic')}: {formatTime(trafficTimestamp)}
        </Box>
      )}
      {exposTimestamp && (
        <Box>
          {translate('tableSourceData.expos')}: {formatTime(exposTimestamp)}
        </Box>
      )}
    </>
  )
}

export default LastDataTab
